exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".widgetTitle{display:table;width:100%}.widgetTitle .iconContainer{width:6%;display:table-cell;vertical-align:top;text-align:center}.widgetTitle .iconContainer .iconBackground{background-color:#00a0f4;margin:.6em;border-radius:.5em}.widgetTitle .iconContainer .iconBackground .icon{margin:.3em;width:2em}.widgetTitle .title{width:90%;display:table-cell;font-size:1.7em;padding-top:.5em}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./assets/sass/data/widgets/widget_title.scss
// module id = 1320
// module chunks = 0